import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'
import { useValue } from '@aytm/app/insights/dashboard/components/hooks'
import { useBlinkSubscription } from '@aytm/app/insights/dashboard/components/hooks/useBlink'
import { useIsLoading } from '@aytm/app/insights/dashboard/components/hooks/useIsLoading'

import './Split.scss'

const CLASS = 'insights-portal-split'

const Split = props => {
  const { getColumnData } = useValue()
  const isLoading = useIsLoading()
  const index = props.index ?? -1
  const item = props.items?.[index] || null

  const targetRef = useBlinkSubscription(item?.uid)

  const { letter, splitText } = useMemo(() => getColumnData(item), [getColumnData, item])

  const className = props.className || CLASS

  return (
    <div ref={targetRef} className={className}>
      <div className={`${className}-description`}>{isLoading ? 'Loading...' : decode(splitText)}</div>
      <div className={`${className}-letter`}>{isLoading ? '' : letter}</div>
    </div>
  )
}

Split.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object)
}

export default Split
